import styled, { css } from "styled-components";
import { getSizeInRem } from "../../methods/common";
import COLORS from "../../constants/colors";
import { TextAreaProps } from "./TextArea.types";
import { getCommonFontStyleMixin } from "../../mixins/font";
export const StyledTextAreaInput = styled.textarea<Partial<TextAreaProps>>`
    font-size: 1rem;
    border: 2px solid ${COLORS.GREY_200};
    color: ${COLORS.GREY_1000};
    border-radius: 4px;
    padding: 0.8em;
    outline: none;
    width: ${({ width }) => (width ? getSizeInRem(width) : "100%")};
    resize: vertical;
    &:focus {
        border: 2px solid ${COLORS.BLUE};
    }

    &::placeholder {
        color: ${COLORS.GREY_400};
    }

    ${({ size }) => {
        switch (size) {
            case "sm":
                return css`
                    ${getCommonFontStyleMixin({ size })};
                `;
            default:
                return css``;
        }
    }};
`;
